import vjs from 'video.js';
import 'videojs-youtube';

(function ($) {
  $(document).on('ready', function () {
    if ($('#vid1').length === 0) {
      return;
    }

    var video = vjs('vid1');

    video.on('play', function (e) {
      $('.featuredVideo__title').fadeOut();
    });

    video.on('pause', function (e) {
      $('.featuredVideo__title').fadeIn();
    });
  })
}(jQuery));



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/_youtube-video.js